import { setCookie } from '@gerenciatd/next.utils.common';

export const QUEUE_NAME = 'Metrics';

export const isNovum = (throwSonda) => {
  try {
    return sessionStorage.getItem('canalVenta') === 'appNovum';
  } catch (err) {
    throwSonda({
      processName: 'isNovum',
      severidad:'WARNING',
      info: null,
      error: err,
      context,
    });
    return null;
  }
}

export const isTelcoSite = () => {
  return window.location.href.indexOf('cliente/areaprivada/#') >= 0;
}

export const isTelcoBuyProcess = () => {
  return window.location.href.indexOf('/particulares/Aplicaciones/Telco/procesoCompra') >= 0;
}

export const setSegmentCookie = (segment, throwSonda) => {
  try {
    if (segment) {
      setCookie('SEG_NAV', segment, 30);
    }

    // fixing errors
  } catch (e) {
    throwSonda({
      processName: 'setSegmentCookie',
      severidad: 'WARNING',
      info: null,
      error: e,
    });
  }
}

export const buildViewData = (data) => {
  let { 'user-type': userType } = data;
  let contextUserRole = '';
  if (userType === 'Gestor') {
    userType = 'Telco';
    contextUserRole = 'gestor';
  }
  return {
    ...data,
    'context-user-role': contextUserRole,
    'user-type': userType,
  };
};


export const isLocalHost = () => {
  let res = false;
  try {
    res = window.location.href.indexOf('127.0.0.1') > -1;
  } catch (err) {
    return res;
  }
  return res;
}

export const isQaEnv = () => {
  let res = false;
  try {
    res = window.location.href.indexOf('movistar.es.cert') > -1
    || window.location.href.indexOf('qa.cms.col.movistar.es') > -1
    || window.location.href.indexOf('col10mgmt.tsm.inet') > -1
    return res;
  } catch (err) {
    return res;
  }
}

export const isProdBucket = () => {
  let res = false;
  try {
    res = window.location.href.indexOf('prod.cms.col.movistar.es') > -1
    return res;
  } catch (err) {
    return res;
  }
}

/**
 * Comprueba si existe tabId
 * @returns {boolean}
 */
const existsTabId = () => {
  try {
    if (window.sessionStorage) {
      return sessionStorage.getItem('mov_tabID') !== null;
    }
    return null;
  } catch (err) {
    return null;
  }
};

/**
 * Genera un id para la pestaña actual del navegador.
 * @returns {number}
 */
const generateTabId = () => {
  const tabId = Date.now(); // Todo
  try {
    if (window.sessionStorage) {
      sessionStorage.setItem('mov_tabID', tabId);
      return sessionStorage.getItem('mov_tabID');
    }
    return `notSupportedSessionStorage-${tabId}`;
  } catch (err) {
    return `notSupportedSessionStorage-${tabId}`;
  }
};

/**
 * Obtiene el tabId de la pestaña actual.
 * @returns {func}
 */
export const getTabId = () => {
  if (existsTabId()) {
    return sessionStorage.getItem('mov_tabID');
  }
  return generateTabId();
};
const newID = () => {  
    return Math.random().toString(36).substr(2, 9);  
};

export const generatePageId = () => {  
    const uuidArray = []
    for (let i=0; i<6; i++){
      uuidArray.push(newID())
    }
    const res = uuidArray.join('-')
    try {
      window.pageId = res;
    } catch(err) {
      console.log(err);
    }
    return res;
}


/**
 * Returns page segment
 * @return {string} 'particulares' by default
 */
export const checkSegment = () => {
  let res = '';

  // intentamos por url empresas
  const { pathname } = window.location;
  if (pathname.indexOf('/empresas') === 0) {
    res = 'empresas';
  }

  // intentamos por url particulares
  if (
    pathname.indexOf('/particulares') === 0
    || pathname.indexOf('/cliente/areaprivada') === 0
  ) {
    res = 'particulares';
  }

  const cookieNav = getCookie('SEG_NAV');
  if (!res && cookieNav && cookieNav !== '') {
    res = cookieNav;
  }
  // en caso de no detectar por url, y en caso de que la cookie venga vacía
  if (!res) {
    res = 'particulares';
  }

  return res;
};
/**
 * Comprueba si hay alguna clave de keys en el objecto que se ha pasado
 * para actualizar objectToCompare
 * @param {Object} objectToSearch objeto donde buscar las claves.
 * @param {*} keys claves que nos importan estas dependerán de la cola en la que estemos
 * @param {*} objectToCompare estructura completa que tenemos en context
 * @returns {boolean}
 */

export const createBasicContext = async () => {
  const environmentImport = await import('@gerenciatd/next.utils.environment');
  const { findOutEnv } = environmentImport
  const environment = findOutEnv();
  const context = {
    environment,
  };
  return context;
};


/**
 * Obtiene la info de hashes de cliente desglosada
 * @param {object} ip3gResponse
 * @returns {object}
 */
export const composeI3Object = (ip3gResponse) => {
  const i3DssObj = ip3gResponse || {};
  /* OTROS QUE NO INTERPRETAMOS DE MOMENTO */

  // const i3D = i3DssObj.d ? i3DssObj.d : '';
  // const i3F = i3DssObj.f ? i3DssObj.f : '';
  // const i3I = i3DssObj.i ? i3DssObj.i : '';
  // const i3K = i3DssObj.k ? i3DssObj.k : '';
  // const i3M = i3DssObj.m ? i3DssObj.m : '';
  // const i3O = i3DssObj.o ? i3DssObj.o : '';

  /* HASHES QUE INTERPRETAMOS */
  const i3A = i3DssObj.a ? i3DssObj.a : '';
  const i3I3I = i3DssObj.i3i ? i3DssObj.i3i : ''; // EL ADICIONAL
  const i3X = i3DssObj.x ? i3DssObj.x : '';
  const i3Z = i3DssObj.z ? i3DssObj.z : '';
  const i3C = i3DssObj.c ? i3DssObj.c : '';
  const i3L = i3DssObj.l ? i3DssObj.l : '';
  const i3P = i3DssObj.p ? i3DssObj.p : '';
  const i3T = i3DssObj.t ? i3DssObj.t : '';
  const i3G = i3DssObj.g ? i3DssObj.g : '';

  /* MAPEO A CONTEXT */
  return {
    userCUCFijoHash: i3C,
    userCUCMovilHash: i3L,
    userCUCPrepagoHash: i3P,
    userIPHash: i3A,
    userOperadorHash: i3X,
    userGl: i3I3I,
    userTelefonoFijoHash: i3T,
    userTelefonoMovilHash: i3G,
    userIdPartyHash: i3Z,
    userClient: !!(i3C || i3L || i3P || i3A || i3T || i3G),
  };
};

/**
 * Combina los valores del ip3g entre las respuestas de servicio y los de IC
 * @param {object} IcHashes
 * @param {object} serviceHashes
 * @returns {object}
 */
export const mergeIp3gHashes = (hashesFromInfoContexto, hashesFromXCOL) => {
  let result = composeI3Object({});
  // la base es el servicio
  result = { 
    ...result,
    ...hashesFromInfoContexto,
  };
  const keys = Object.keys(hashesFromXCOL);
  // recorremos todas las propiedades de xcol cookie
  keys.forEach((keyName) => {
    if (!result[keyName] && hashesFromXCOL[keyName]) {
      result[keyName] = hashesFromXCOL[keyName];
    }
  });
  return result;
};

/**
 * Transforma el string de xcol a ip3hashes
 * @param {string} IcHashes
 * @returns {object}
 */
export const tranformXcol2Ip3Hashes = (xcol='') => {
  let res = xcol;
  try {
    res = window && window.atob(res.split('.')[1]);
    res = JSON.parse(res);
    res = composeI3Object(res);
  } catch(error) {
    res = composeI3Object({});
  }
  return res;
};

/**
 * Obtiene la variable 'mockedContext' del sessionStorage
 * @returns {object} Objeto con los valores de mockedContext (null si no existe)
 */
export const getMockedContext = (envName = 'prod') => {
  if (envName !== 'prod') {
    try {
      const mockString = sessionStorage.getItem('mockedContext');
      const mock = JSON.parse(mockString);
      if(mock){
        return mock;
      }
      return {};
    } catch (err) {
      return {};
    }
  }
  return {};
};

export const getMsieVersion = () => {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ');
  return (msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./));
}

export const redirectIE2NotSuported = () => {
  let rightPath = false;
  const movistarHost = window.location.host.indexOf('movistar.es') > -1;
  const firstPathToken = window.location.pathname.split('/')[1];
  const IE_PATHS = ['particulares', 'empresas', 'autonomos', ''];
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < IE_PATHS.length; i++) {
    if (!rightPath && firstPathToken === IE_PATHS[i]) {
      rightPath = true;
    }
  }

  if (movistarHost && getMsieVersion() && rightPath) {
    window.location.pathname = '/navegador-no-soportado'
  }
}

export const ALLOWED_TCOLAPI_HOST = [
  'col10mgmt.tsm.inet',
  'movistar.es',
  'www.movistar.es',
  'movistar.cert',
  'www.movistar.cert',
]

export const checkTcolApiAllowed = () => {
  let res = false;
  if (window && window.location && window.location.host) {
    const { host } = window.location;
    // 1) si contiene cms.col
    if ((host.indexOf('.cms.col') > -1)) {
      res = true;
    }
    // 2) si es algo de los hosts
    if (!res && ALLOWED_TCOLAPI_HOST.includes(host)) {
      res = true;
    }
  }

  return res;
}
